export default "__VITE_ASSET__dd7fbfc3__"